import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted mt-2" }

import { computed, onMounted, watch, shallowReactive, nextTick, ref, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'

    import { useFinishedProjectsPageQueryV1 } from '@Quest/Portfolios/queries-vue-composables'
    import { useSaveViewFinishedProjectsPageCommandV1 } from '@Quest/Portfolios/commands-vue-composables'

    import { useSetLifecycleResumedCommandV1 } from '@Quest/Projects/commands-vue-composables'

    import { FinishedProjectsPageReadModel } from '@Quest/Portfolios/readmodels'
    import { GridProjectReadModel } from '@Quest/Projects/readmodels'

    import { ProjectsGridViewModel } from '@Quest/Projects/Components/ProjectsGrid'
    import ProjectsGrid from '@Quest/Projects/Components/ProjectsGrid.vue'

    import { ProjectResumedLifecycleSetterViewModel } from '@Quest/Projects/Components/ProjectResumedLifecycleSetter'
    import ProjectResumedLifecycleSetter from '@Quest/Projects/Components/ProjectResumedLifecycleSetter.vue'



    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FinishedProjectsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))



    // ======================
    // Query
    // ======================

    const {
        runFinishedProjectsPageQueryV1,
        modelFinishedProjectsPageQueryV1
    } = useFinishedProjectsPageQueryV1(workspaceId, tchProjectId)

    const rm = modelFinishedProjectsPageQueryV1 as Ref<FinishedProjectsPageReadModel | null>

    const portfolioId = computed(() => rm.value?.PortfolioId ?? '')
    const portfolioName = computed(() => rm.value?.PortfolioName ?? null)



    // ======================
    // Commands
    // ======================

    const {
        invokeSaveViewFinishedProjectsPageCommandV1,
        succeedSaveViewFinishedProjectsPageCommandV1
    } = useSaveViewFinishedProjectsPageCommandV1(workspaceId, portfolioId)

    const lastResumedId = ref<string | null>(null)

    const {
        invokeSetLifecycleResumedCommandV1,
        succeedSetLifecycleResumedCommandV1
    } = useSetLifecycleResumedCommandV1(workspaceId, portfolioId, lastResumedId)



    // ======================
    // ViewModels
    // ======================

    const grid = shallowReactive(new ProjectsGridViewModel())
    const projectResumedLifecycleSetter = shallowReactive(new ProjectResumedLifecycleSetterViewModel())



    // ======================
    // Handlers
    // ======================

    function handleShowGridColumnsEditor()
    {
        grid.showGridColumnsEditor()
    }

    function handleSaveViewSettings()
    {
        invokeSaveViewFinishedProjectsPageCommandV1({
            Grid: grid.getJson()
        })
    }

    function handleClearGridFilters()
    {
        grid.clearFilters()
    }

    function handleExportGrid()
    {
        grid.exportGrid()
    }

    function handleResumed(projectId: string)
    {
        lastResumedId.value = projectId
        invokeSetLifecycleResumedCommandV1()
    }



    // ======================
    // Query Watchers
    // ======================

    watch(rm, (current) =>
    {
        if (!current) return

        nextTick(() =>
        {
            grid.renderGrid(
                current.Grid.IdField,
                current.Grid.Fields,
                current.Grid.DefaultFieldIds,
                current.Grid.Options
            )

            grid.setProjects(current.Projects.map(p => p.Properties))
        })
    })



    // ======================
    // Command Watchers
    // ======================

    watch(succeedSaveViewFinishedProjectsPageCommandV1, (c, p) =>
    {
        if (c && !p)
        {
            alert('Saved')
        }
    })

    watch(succeedSetLifecycleResumedCommandV1, (c, p) =>
    {
        if (c && !p && lastResumedId.value && rm.value)
        {

            const projectId = lastResumedId.value

            rm.value.Projects = rm.value.Projects.filter(a => a.Id !== projectId)

            grid.removeRowById(projectId)

            projectResumedLifecycleSetter.close()

            lastResumedId.value = null
        }
    })



    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Portfolio Finished | TransparentChoice"
        runFinishedProjectsPageQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ProjectResumedLifecycleSetter, {
      viewModel: _unref(projectResumedLifecycleSetter),
      onConfirm: handleResumed
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, _toDisplayString(portfolioName.value), 1 /* TEXT */),
          _cache[0] || (_cache[0] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Finished projects", -1 /* CACHED */))
        ]),
        _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, [
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-outline-secondary",
            style: {"padding":"0.7em 2em"},
            onClick: handleSaveViewSettings
          }, "Save")
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
      _createElementVNode("div", { class: "toolbar" }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createCommentVNode("<button type=\"button\" class=\"btn btn-outline-secondary\">Action ({{selectedIds.length}})</button>")
        ], -1 /* CACHED */)),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-1",
            onClick: handleShowGridColumnsEditor
          }, "Edit columns"),
          _createElementVNode("div", { class: "btn-group" }, [
            _cache[1] || (_cache[1] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary dropdown-toggle mr-1",
              "data-toggle": "dropdown"
            }, " Actions ", -1 /* CACHED */)),
            _createElementVNode("div", { class: "dropdown-menu dropdown-menu-right" }, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: handleClearGridFilters
              }, "Clear Filters")
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            onClick: handleExportGrid,
            title: "Download to spreadsheet"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fa fa-download fa-lg" }, null, -1 /* CACHED */)
          ]))])
        ])
      ]),
      _createVNode(ProjectsGrid, { viewModel: _unref(grid) }, null, 8 /* PROPS */, ["viewModel"])
    ])
  ]))
}
}

})